import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import { useCartSupportChats, usePostCartSupportChat, useUpdateSupportChatFiles } from 'services/Data/SupportChatServices';
import SupportChatSharedContainer from './SupportChatSharedContainer';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';
import SupportFileUploadModal from './SupportFileUploadModal';

const AssociatedCartSupportChats = ({ disableSupportChat }) => {
  let { cartId } = useParams();

  const { data: supportChats, isFetching: gettingSupportChats } = useCartSupportChats(cartId);
  const { mutateAsync: postCartSupportChat, isPending: isPostingCartSupportChat } = usePostCartSupportChat();

  const { mutateAsync: uploadChatFiles } = useUpdateSupportChatFiles();
  const [files, setFiles] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState();

  const handleCloseUploadModal = useCallback(() => setOpenUploadModal(false), []);
  const handleOpenUploadModal = useCallback(() => setOpenUploadModal(true), []);
  const handleAddFile = useCallback(files => setFiles(prev => [...prev, ...files]), []);
  const handleResetFile = useCallback(() => setFiles([]), []);

  const handleRemoveFile = useCallback(fileToRemove => setFiles(prev => prev.filter(f => f.path !== fileToRemove.path)), []);

  const handleAddNewNote = useCallback(
    newNote => {
      postCartSupportChat({ note: newNote, cart_Id: cartId }).then(({ data: note }) => {
        uploadChatFiles({ files, entityId: note.id, type: BlobStorageTypeEnumValue.SupportChat }).then(_ => {
          handleResetFile();
        });
      });
    },
    [postCartSupportChat, files, uploadChatFiles, handleResetFile, cartId],
  );

  return (
    <>
      <SupportFileUploadModal handleAddFile={handleAddFile} onClose={handleCloseUploadModal} show={openUploadModal} />
      <SupportChatSharedContainer
        fromProfile
        gettingSupportChats={gettingSupportChats}
        supportChats={supportChats}
        handleAddNewNote={handleAddNewNote}
        isPostingSupportChat={isPostingCartSupportChat}
        disableSupportChat={disableSupportChat}
        openUploadFileModal={handleOpenUploadModal}
        files={files}
        handleRemoveFile={handleRemoveFile}
        handleResetFile={handleResetFile}
      />
    </>
  );
};

export default AssociatedCartSupportChats;
